// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Selectors
import { getPublishPreviewPasswordValidated, getPublishPreviewStartingBoard } from '../preview/previewSelector';

// Utils
import { getElementId, getIsPublishedPasswordProtected } from '../../../common/elements/utils/elementPropertyUtils';

// Components
import BoardPreviewPasswordProtectedForm from './BoardPreviewPasswordProtectedForm';

// If the current board doesn't have a token set, then the password hasn't been entered.
const mapStateToProps = createSelector(
    getPublishPreviewStartingBoard,
    getPublishPreviewPasswordValidated,
    (publishPreviewStartingBoard, passwordValidated) => {
        const isPasswordProtected = getIsPublishedPasswordProtected(publishPreviewStartingBoard);

        return {
            startingBoardId: getElementId(publishPreviewStartingBoard),
            isPasswordProtected,
            passwordValidated,
        };
    },
);

const BoardPreviewPasswordProtectedContainer = (props) => {
    const { isPasswordProtected, passwordValidated, startingBoardId } = props;

    if (!isPasswordProtected || passwordValidated) return React.Children.only(props.children);

    return <BoardPreviewPasswordProtectedForm startingBoardId={startingBoardId} />;
};

BoardPreviewPasswordProtectedContainer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    isPasswordProtected: PropTypes.bool,
    passwordValidated: PropTypes.bool,

    startingBoardId: PropTypes.string,
    dispatchGetPermissionsForBoard: PropTypes.func,
};

export default connect(mapStateToProps)(BoardPreviewPasswordProtectedContainer);
